import { HttpParameterCodec, HttpParams } from '@angular/common/http';

export class CustomEncoder implements HttpParameterCodec {
  encodeKey(key: string): string {
    return encodeURIComponent(key);
  }

  encodeValue(value: string): string {
    return encodeURIComponent(value);
  }

  decodeKey(key: string): string {
    return decodeURIComponent(key);
  }

  decodeValue(value: string): string {
    return decodeURIComponent(value);
  }
}

export const generatePlatformQueryParameters = (
  httpParamsAPI: HttpParams,
  qParams: { [key: string]: any },
  isCapacitor: boolean = false,
): any => {
  const setMultiple = (api: HttpParams, values: Record<string, any>) => {
    for (const key in values) {
      if (values.hasOwnProperty(key)) {
        api = api.set(key, values[key]);
      }
    }
    return api;
  };

  return !isCapacitor ? qParams : setMultiple(httpParamsAPI, qParams);
};
